<div class="content-container bg-white-no-shadow">

    <!-- Cockpit Selector -->
    @if (craningBookingUtils.isExploitantView()) {
        <div class="btn-group" role="group">
            <input class="btn-check" type="radio"
                   [value]="CraningView.BookingView">
            <label class="btn btn-toggle btn-toggle-left h-auto"
                   [ngClass]="{ active: craningView === CraningView.BookingView }"
                   translate="services.craning.viewSelector.booking"
                   (click)="changeCraningView(CraningView.BookingView)"
                   (keyup)="changeCraningView(CraningView.BookingView)"></label>

            <input class="btn-check" type="radio"
                   [value]="CraningView.BillingView">
            <label class="btn btn-toggle btn-toggle-right h-auto"
                   [ngClass]="{ active: craningView === CraningView.BillingView }"
                   translate="services.craning.viewSelector.billing"
                   (click)="changeCraningView(CraningView.BillingView)"
                   (keyup)="changeCraningView(CraningView.BillingView)"></label>
        </div>
    }

    @if (craningView === CraningView.BookingView) {
        <app-craning-booking
            [service]="service"></app-craning-booking>
    } @else if (craningView === CraningView.BillingView && craningBookingUtils.isExploitantView()) {
        <app-craning-billing
            [service]="service"></app-craning-billing>
    }
</div>
